<div [className]="className">
  {{ text }}
</div>
